export const getChannelLogoPath = (channelName: string): string => {
    const basePath = '/assets/channels/light';
    const name = channelName.toLowerCase().trim();

    if (name === 'ziggo sport') return `${basePath}/ziggo_sport_1.png`;

    const numberMatch = name.match(/ziggo\s*sport\s*(\d{1,2})/);
    if (numberMatch && numberMatch[1]) {
        return `${basePath}/ziggo_sport_${numberMatch[1]}.png`;
    }

    if (name.includes('voetbal')) return `${basePath}/ziggo_sport_2.png`;
    if (name.includes('racing')) return `${basePath}/ziggo_sport_3.png`;
    if (name.includes('golf')) return `${basePath}/ziggo_sport_4.png`;
    if (name.includes('docu')) return `${basePath}/ziggo_sport_5.png`;
    if (name.includes('tennis')) return `${basePath}/ziggo_sport_6.png`;
    if (name.includes('select')) return `${basePath}/ziggo_sport.png`;

    return `${basePath}/ziggo_sport.png`;
};
